import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { FeatureFlagsEnum } from './feature-flags-enum'

export const useFeatureFlag = (flag: FeatureFlagsEnum): boolean => {
  return useFeatureIsOn(flag)
}
